export enum ClassActuality
{
    Current = 1,
    Last = 2,
    Next = 4,
    Archive = 8,
    Future = 16
}
